import { CheckoutOrderReviewCustomerProps } from './checkout-order-review-customer.props';
import React from 'react';
import LazyLoad from 'react-lazyload';

export const CheckoutOrderReviewCustomerMolecule = (
  props: CheckoutOrderReviewCustomerProps
) => {
  return (
    <div className="flex flex-row justify-between lg:justify-start my-4">
      <div className="w-11/12 text-waldo-blue">
        <label className="text-lg font-semibold mt-1.5 mb-2">
          {props.title}
        </label>
        {props.children}
      </div>
      <div className="w-1/12 mt-1.5" onClick={() => props.click()}>
        <LazyLoad offset={15}>
          <img
            src="/images/icons/edit-icon.svg"
            title={`Edit ${props.title}`}
            className="hover:translate-x-1"
          />
        </LazyLoad>
      </div>
    </div>
  );
};
